<div class="gray-card text-left">
  <ng-container *ngFor="let keyValue of keyValues; let last = last;">
    <div [class.mb-1]="!last" *ngIf="!hideEmptyValues || keyValue?.value">
      <span>{{keyValue.key | translate}}: </span>
      <span class="bold">{{keyValue.value | translate}}</span>
    </div>
  </ng-container>
</div>
